import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Opens the project-upload dialog from anywhere.
 *
 * The dialog lives in MainLayoutComponent because it must survive navigation — an
 * upload in progress cannot be torn down by a route change — but the place a user
 * asks for it is the SELECTION screen, which is where they notice the project they
 * wanted is not listed. Those are two different components, so the request travels
 * through here rather than through an @Output chain across a router-outlet.
 *
 * A Subject, not a BehaviorSubject: this is an event, and a replayed one would
 * reopen the dialog on every later subscription.
 *
 * IT CARRIES THE FILE NOW. The old `open()` asked main-layout to show a picker,
 * and NOTHING SUBSCRIBED — the button on the selection screen emitted into the
 * void, which is why it appeared to open a blank pane. Rather than reconnect a
 * request for a picker, the selection screen opens the OS picker itself and sends
 * the file: one dialog instead of two, and the browser's own picker already
 * enforces the accepted types.
 */
@Injectable({ providedIn: 'root' })
export class UploadDialogService {
  private readonly uploads = new Subject<File>();

  /** Emits the file a user chose, for whoever owns the upload pipeline. */
  readonly upload$: Observable<File> = this.uploads.asObservable();

  /** Hand off a chosen file to the upload flow. */
  uploadFile(file: File): void {
    this.uploads.next(file);
  }
}
